import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, className = "" }) => (
  <div
    className={`flex items-center gap-3 text-xs uppercase tracking-[0.28em] text-brand-gold ${className}`}
  >
    <span className="h-px w-8 bg-brand-gold/70" />
    {children}
  </div>
);
